  query getTopCustomerData(
    $clientId: ID
    $projectId: ID
    $productIds: [ID]
    $startDate: AWSDateTime
    $endDate: AWSDateTime
    $pageSize: Int
    $offset: Int
    $sortDirection: String
    $sort: String
  ) {
    customers: SalesAnalyticsGetCustomerTotals(
      startDate: $startDate
      endDate: $endDate
      clientId: $clientId
      projectId: $projectId
      productIds: $productIds
      pageSize: $pageSize
      offset: $offset
      sortDirection: $sortDirection
      sort: $sort
      productView: BUNDLE
    ) {
      customerId
      quantity
      sales
    }
  }